import script from "./Heading.vue?vue&type=script&setup=true&lang=js"
export * from "./Heading.vue?vue&type=script&setup=true&lang=js"

import "./Heading.vue?vue&type=style&index=0&id=a9388cfe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9388cfe"]])

export default __exports__